export enum PaymentMethod {
  CARD = "Card",
}
